<template>
    <div class="default_list">
         <div class="nav app_title_list">
            <mt-tab-item @click.native="prevent('tab-container1')"> <span :class="active == 'tab-container1'?'title_switch_if':'title_switch'">公示公告</span> </mt-tab-item>
            <mt-tab-item @click.native="prevent('tab-container2')"><span :class="active == 'tab-container2'?'title_switch_if':'title_switch'">濮阳要闻</span></mt-tab-item>
        </div>
            
        <div class="page-tab-container">
            <mt-tab-container class="page-tabbar-tab-container" v-model="active" swipeable>
                <mt-tab-container-item id="tab-container1">
                    <!-- cell组件 -->
                    <AppContentLista></AppContentLista>
                </mt-tab-container-item>
                <mt-tab-container-item id="tab-container2">
                    <!-- cell组件 -->
                    <AppContentList></AppContentList>
                </mt-tab-container-item>
            </mt-tab-container>
        </div>
    </div>
</template>
<script>
// 公示公告
import AppContentLista from '@/components/appModule/homePageAppTwo/appContentLista/index'
import AppContentList from '@/components/appModule/homePageApp/appContentList/index'


export default {
  name: 'page-tab-container',
  data() {
    return {
      active: 'tab-container1'
    };
  },
  components:{
      AppContentList,
      AppContentLista
  },
  methods:{
    prevent(val){
      this.active = val
    }
  }
};
</script>
<style lang="">
    .default_list{
        padding-top:1rem;
    }
  .item {
    display: inline-block;
  }
 

 
  .link {
    color: inherit;
    padding: 20px;
    display: block;
  }
  .app_title_list{
      display:flex;
      justify-content: space-around;
  }
    .app_title_list .mint-tab-item{
    padding:0;
    text-align: center;
    font-size: 1.4rem !important;
  }

  .app_title_list .mint-tab-item .mint-tab-item-label{
    font-size: 1.2rem !important;
    font-family: Source Han Sans CN;
  }
  .title_switch{
    height:2.2rem;
    line-height: 2.2rem;
    display: block;
    border-bottom:0.01rem solid #fff;
  }
  .title_switch_if{
    height:2.2rem;
    line-height: 2.2rem;
    display: block;
    color: #C90304;
    font-weight: bolder;
    border-bottom:0.1rem solid #C90304;
  }
</style>


// WEBPACK FOOTER //
// src/components/appModule/homePageApp/index.vue